export default "__VITE_ASSET__Bl7Pm1PD__"